import { CSSProperties, PropsWithChildren } from 'react';
import Text from '../Text';
import * as S from './styles';
import useBreakpoint from '@/hooks/useBreakpoint';

export type BlocoInformacaoProps = PropsWithChildren<{
  id?: string;
  $titulo?: string;
  $style?: CSSProperties;
  headerStyle?: CSSProperties;
  $childrenContainerstyle?: CSSProperties;
}>;

export default function BlocoInformacao(props: BlocoInformacaoProps) {
  const {
    $titulo,
    $style,
    headerStyle,
    $childrenContainerstyle,
    children,
    ...rest
  } = props;

  const { breakpoint } = useBreakpoint();

  return (
    <S.Container $breakpoint={breakpoint} style={$style} {...rest}>
      <Text
        $size={breakpoint === 'mobile' ? 5 : 6}
        $color="neutral"
        $weight="bold"
        $align="left"
        $highContrast={true}
        $text={$titulo}
        style={{ alignSelf: 'flex-start', ...headerStyle }}
      />
      <S.ChildrenContainer style={$childrenContainerstyle}>
        {children}
      </S.ChildrenContainer>
    </S.Container>
  );
}
